/** Maximum nesting accepted before recursive consumer input is rejected. @internal */
export const maximumConfigDepth = 128;

/** Maximum aggregate nodes accepted from one consumer input. @internal */
export const maximumConfigNodes = 10_000;
